var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon Facebook",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 351",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#007F9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 18.027h2.269v9.343a.334.334 0 00.334.334h3.848a.334.334 0 00.334-.334v-9.3h2.609a.334.334 0 00.332-.3l.4-3.44a.334.334 0 00-.332-.372h-3.009v-2.151c0-.65.35-.98 1.04-.98h1.965a.334.334 0 00.334-.334V7.336A.334.334 0 0022.124 7h-2.827a5.189 5.189 0 00-3.4 1.279 3.558 3.558 0 00-1.183 3.163v2.521h-2.38a.334.334 0 00-.337.337v3.4a.334.334 0 00.337.327z",
    fill: "#fff"
  })));
}

export default SvgFacebook;